export type MutatePlayerForm = {
  firstName: string;
  lastName: string;
  playerHeight: string;
  gender: string;
  level: string;
  parentFirstName: string;
  parentLastName: string;
  phoneNumber: string;
  countryCode?: string | undefined;
  altPhoneNumber: string;
  altCountryCode?: string | undefined;
  email: string;
  streetAddress: string;
  streetAddress2: string;
  city: string;
  state: string;
  zipCode: string;
  birthDate: Date | null;
  needClubs: string;
  dominantHand: string;
  avatar?: {
    uri: string;
    fileSize?: number;
  };
};

export type MutatePlayerOption = {
  value: string;
  label: string;
};
